import API from '@/api/Shop'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('Shop')

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
}

const getters = {
  ...Mixin.getters,
  getCategory: state => id => {
    return state.item.categories.find(category => category.id === id)
  },
  getCategoryStatus: (state, getters) => id => {
    return (getters.getCategory(id) || {}).status
  },
  isCategoryLocked: (state, getters) => id => {
    return ['accepted'].includes(getters.getCategoryStatus(id))
  },
  reference: state => {
    return state.item.reference ? state.item.reference.id : null
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
